module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-mobile-es.5a1e05fb.png";